import { render, staticRenderFns } from "./AdminProducer.vue?vue&type=template&id=39048318&"
import script from "./AdminProducer.vue?vue&type=script&lang=js&"
export * from "./AdminProducer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports